import { z } from 'zod';

import defineBlock from '../helpers/defineBlock';
import { BlockSchema } from '../types';

export const ContainerBlockSchema = defineBlock(
  'Container',
  z.object({
    get blocks() {
      return z.array(BlockSchema).nullish();
    },
  })
);
export type TContainerBlock = z.infer<typeof ContainerBlockSchema>;
